// need to work: need to change the color import from #307FE2 to $color-blue
import { Component, Renderer2, ElementRef } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { UploadFlatFileDialogService } from './upload-flat-file-dialog.service';

@Component({
    selector: 'flat-file-clickable-button',
    template: `
        <button (click)='clicked($event)' class='btn' [ngClass]="{'source-title': isFlatFile}">{{this.cell.row}}</button>
    `,
    styles: [
        `.btn {
            height: 21px;
            font-family: SourceSansPro;
            font-size: 14px;
            color: rgba(0,0,0, 0.85);
            background-color: transparent;
            border: none;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            position:absolute;
            border: none;
            width: 100%;
            text-align: left;
            cursor: default;
        }`,
        `.source-title{
            color: #307FE2;
            cursor: pointer;
        }`
    ]
})
export class FlatFileClickableButtonComponent implements ICellRendererAngularComp {
    private params: any;
    public cell: any;
    isFlatFile = false;

    constructor(
        private _uploadFlatFileDialogService: UploadFlatFileDialogService,
        private _renderer2: Renderer2,
        private _elm: ElementRef
    ) {
    }

    agInit(params: any): void {
        this.params = params;
        this.cell = { row: params.value, col: params.colDef.headerName };
        if (params.data.type === 1) {
            this._renderer2.removeAttribute(this._elm.nativeElement.querySelector('.btn'), 'disabled');
            this.isFlatFile = true;
        } else {
            this._renderer2.setAttribute(this._elm.nativeElement.querySelector('.btn'), 'disabled', 'disabled');
            this.isFlatFile = false;
        }
    }

    public clicked(cell: any): void {
        this._uploadFlatFileDialogService.dialogOpen$.next(this.params);
    }

    refresh(): boolean {
        return false;
    }
}
